import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  detailSubmissionChannel = new Subject();
  repository = new DataTableRepository();
  inactiveChannel = new Subject();
  processChannel = new Subject();
  generateChannel = new Subject();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.inactiveChannel.next({ status: apiResponse.INITIAL });
    this.processChannel.next({ status: apiResponse.INITIAL });
    this.generateChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    this.rowtableChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchRowTable(query, cancelToken)
      .then((result) => {
        this.rowtableChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchDetailSubmission = async (query, cancelToken) => {
    this.detailSubmissionChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchDetailSubmission(query, cancelToken)
      .then((result) => {
        this.detailSubmissionChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.detailSubmissionChannel.next({
          status: apiResponse.ERROR,
          data: error,
        });
      });
  };

  fetchInactive = async (query) => {
    this.inactiveChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchInactive(query)
      .then((result) => {
        this.inactiveChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchProcess = async (query) => {
    try {
      this.processChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchProcess(query)
        .then((result) => {
          this.processChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.processChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchGenerate = async (query) => {
    try {
      this.generateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGenerate(query)
        .then((result) => {
          this.generateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.generateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };
}

export default DataTableBloc;
